export enum DownloadFormat {
  HTML = '.html',
  PDF = '.pdf',
  ZIP = '.zip',
  DOC = '.doc',
  DOCX = '.docx',
  ODT = '.odt',
  TXT = '.txt',
  CSV = '.csv',
  ODS = '.ods',
  XLS = '.xls',
  XLSX = '.xlsx',
  PPT = '.ppt',
  PPTX = '.pptx',
  ODP = '.odp',
  PNG = '.png',
  JPG = '.jpg',
  JPEG = '.jpeg',
  P7M = '.p7m',
}
